// Parent route for /your-people/* — pass-through, children handle UI.
import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/your-people')({
  component: () => <Outlet />,
})
